import Modal from 'bootstrap/js/dist/modal.js';

import './vendor/jquery-ui.min.js';
import './vendor/modernizr.custom.js';
import './modules/menu-push.js';

import {i18n} from './utils.js';

// Autocomplete Search
function initSearchField() {
  const searchField = $('#search-field');

  if (!searchField.length > 0) return false;

  if (searchField.val() == '') {
    searchField.removeClass('search_active');
    searchField.addClass('search_inactive');
  }

  searchField
    .autocomplete({
      minChars: 2,
      scroll: false,
      scrollHeight: 400,
      source: searchDataUrl,
      appendTo: '.search-results',
      select: function (event, ui) {
        if (
          ui.item.categoryPath == undefined &&
          ui.item.value == 'moreResults'
        ) {
          $('#searchForm').submit();
          return false;
        }
        $('#search-field').val('');
        $('#search-field').addClass('ac_loading');
        document.location.href = ui.item.url;
        return false;
      },
    })
    .data('ui-autocomplete')._renderItem = function (ul, item) {
    // ul.removeClass();

    if (item.categoryPath == undefined && item.value == 'moreResults') {
      const html = '<a href="#">' + item.name + '</a>';

      return $('<li class="moreResults">')
        .data('item.autocomplete', item)
        .append(html)
        .appendTo(ul);
    }

    let html =
      '<a href="' +
      item.url +
      '"><div class="product-image"><img src="' +
      item.image +
      '" class="ac_img" /></div>' +
      '<div class="product-meta">' +
      '<div class="name">' +
      item.name +
      '</div>';

    if (item.categoryPath.length > 0) {
      html += '<div class="category">in ';
      $.each(item.categoryPath, function (i, category) {
        if (i > 0) html += ' &gt; ';
        html += category;
      });
      html += '</div>';
    }

    html += '</div>';

    return $('<li>').data('item.autocomplete', item).append(html).appendTo(ul);
  };
}

// B2B Warning
const B2BWarning = (function () {
  const cookieDev = false; // true enables dev mode, allowing you to style the warning
  const cookieName = 'b2bConsent'; // Name of our cookie
  const warningID = 'b2b_overlay';
  const $warning = $('#' + warningID).detach();

  function showWarning() {
    // show warning
    const $modal = $warning.find('.modal');
    $('body').append($warning);
    const bsModal = new Modal($modal[0]);
    bsModal.show();

    // add close event handler
    const $b2bConsentCheckbox = $('#b2bconsent'),
      $b2bConsentButton = $('#b2bconsentSubmit');

    $b2bConsentCheckbox.on('change', function (e) {
      $b2bConsentButton.attr('disabled', !e.target.checked);
    });

    $b2bConsentButton.on('click', function (e) {
      Cookies.set(cookieName, true, {expires: 365});

      bsModal.hide();
      $('.modal-backdrop').remove();
    });
  }

  function hideBanner() {
    $warning.slideUp(150);
  }

  function init() {
    if (Cookies.get(cookieName)) {
      if (cookieDev) {
        showWarning();
      }
    } else {
      showWarning();
    }
  }

  return {
    init: init,
  };
})();

(function ($) {
  $('.bannerMenu__link').hover((e) => {
    $(e.target).toggleClass('hover');
  });

  // init B2B Warning
  B2BWarning.init();

  // initialize search
  initSearchField();

  // init mobile menu
  $('nav.mobile').menuPush({
    type: 'cover',
  });

  // handle small cart and menu for mobile
  const body = $('body'),
    searchForm = $('#searchForm'),
    searchTrigger = $('.search-trigger'),
    overlay = $('<div id="overlay" />');

  const closeTools = () => {
    searchForm.removeClass('active');
    overlay.removeClass('active');
  };

  $('.wrapper').append(overlay);

  overlay.on('click', (e) => {
    closeTools();

    return false;
  });

  searchTrigger.on('click', (e) => {
    if (searchForm.hasClass('active')) {
      closeTools();
    } else {
      closeTools();
      searchForm.addClass('active');
      overlay.addClass('active');
    }
  });
})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/application.js